import * as React from 'react';
import { ActivityReservation } from '../../../model/activities';
import { Typography, Grid, Divider, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import DeleteButtonOnlyIcon from '../../Button/DeleteButtonOnlyIcon';
interface IProps {
    reservations: ActivityReservation[];
    removeReservation: (scheduleId: string, id: string) => any;
    loading: boolean;
    classes: any;
}
const Row = (classes, r: ActivityReservation, idx: number, removeReservation: (scheduleId: string, id: string) => any) => (
    <Grid key={'key' + idx} style={{ width: "100%" }}><Grid container className={classes.tableRow} >
        <Grid item xs={12} sm={4} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{r.surname}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{r.name}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{r.email}</Typography>
        </Grid>
        <Grid item sm={1} className={classes.tableCell}>
            <DeleteButtonOnlyIcon onClick={() => removeReservation(r.activityScheduleId, r._id)} />
        </Grid>
    </Grid>
        <Divider style={{ width: '100%' }} /></Grid>)

export const ReservationsList = (props: IProps) => {
    // const [sortAttribute, setSortAttribute] = React.useState('');
    // const [page, setPage] = React.useState(0);
    // const [sort, setSort] = React.useState('');

    const { classes, reservations } = props;
    return (
        <Grid container>
            {props.loading ?
                <Grid item sm={12} spacing={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress /><Typography component="span" className={classes.Typography}>Aggiornamento Lista</Typography>
                </Grid>
                :
                <div style={{ width: "100%" }}>
                    <Grid container className={classes.tableHeader}>
                        <Grid item sm={4} className={clsx(props.classes.tableHeaderCell)}>
                            <Typography className={classes.detailHeaderText}>Cognome</Typography>
                        </Grid>
                        <Grid item sm={4} className={clsx(props.classes.tableHeaderCell)} >
                            <Typography className={classes.detailHeaderText}>Nome</Typography>
                        </Grid>
                        <Grid item sm={3} className={clsx(props.classes.tableHeaderCell, "last")}>
                            <Typography className={classes.detailHeaderText}>Email</Typography>
                        </Grid>

                    </Grid>
                    <Grid container className={classes.table}>
                        {reservations.map((f, idx) => { return Row(classes, f, idx, props.removeReservation) })}
                    </Grid>
                </div>}
        </Grid>
    );
};
